import React, { useContext } from 'react'
import { Avatar, Button, Dropdown, Layout } from 'antd'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { images } from '../images'
import { MenuItems } from './MenuItems'
import { AuthContext } from '../context/AuthProvider'
import { colors } from '../util/colors'

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const { Header, Footer, Content } = Layout

export const AppShell = ({ children }: { children: JSX.Element }) => {
  const { userData } = useContext(AuthContext)
  return (
    <Layout
      className="layout"
      style={{ margin: '-8px', padding: 16, height: '100vh' }}
    >
      <Header
        style={{
          justifyContent: 'space-between',
          display: 'flex',
          alignItems: 'center',
          backgroundColor: colors.tokenBg,
        }}
      >
        <Link to="/">
          <img src={images.logo} alt="" style={{ width: 200 }} />
        </Link>
        <Dropdown overlay={MenuItems()} trigger={['click']}>
          <Button
            type="link"
            data-testid="avatarBtn"
            style={{ height: '100%' }}
            className="ant-dropdown-link"
            onClick={(e) => e.preventDefault()}
          >
            {userData && (
              <UserInfo>
                <Avatar
                  size={32}
                  icon={
                    <img
                      src={`https://avatars.dicebear.com/api/bottts/${userData?.address}-${userData?.chainId}.svg`}
                      alt=""
                    />
                  }
                  src={undefined}
                />
              </UserInfo>
            )}
          </Button>
        </Dropdown>
      </Header>
      <Content>{children}</Content>
      <Footer style={{ position: 'fixed', bottom: 0, zIndex: 1, width: '100%' }}>
        <div style={{ textAlign: 'center' }}>©2022 Gateway GROW Launchpad</div>
      </Footer>
    </Layout>
  )
}
